import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_DEGREE,
  GET_DEGREES,
  ADD_DEGREE,
  UPDATE_DEGREE,
  DELETE_DEGREE
} from '@/queries/modules/common-data/degree';

export async function getDegrees(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_DEGREES,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setDegrees', data.getDegrees);
      context.commit('setSuccess', null);
      return data.getDegrees
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getDegree(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_DEGREE,
        variables: payload
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setDegree', data.getDegree);
      context.commit('setSuccess', null);
      return data.getDegree
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addDegree(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_DEGREE,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const degrees = [...context.state.degrees];
      degrees.push(data.addDegree);
      context.commit('setDegrees', degrees);
      context.commit('setSuccess', newItemSuccess(data.addDegree.nameLocal));

      return data.addDegree
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateDegree(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_DEGREE,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.degrees.findIndex(item => item.id === data.updateDegree.id);
      const degrees = [
        ...context.state.degrees.slice(0, index),
        data.updateDegree,
        ...context.state.degrees.slice(index + 1)
      ];
      context.commit('setDegrees', degrees);
      context.commit('setSuccess', updateItemSuccess(data.updateDegree.nameLocal));

      return data.updateDegree
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteDegree(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_DEGREE,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.degrees.findIndex(item => item.id === data.deleteDegree.id);
      const degrees = [
        ...context.state.degrees.slice(0, index),
        ...context.state.degrees.slice(index + 1)
      ];
      context.commit('setDegrees', degrees);
      context.commit('setSuccess', deleteItemSuccess(data.deleteDegree.nameLocal));

      return data.deleteDegree
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

